import { runIfFn } from "@chakra-ui/utils";
export { runIfFn };
export function mode(light, dark) {
  return function (props) {
    return props.colorMode === "dark" ? dark : light;
  };
}
export function orient(options) {
  var orientation = options.orientation,
    vertical = options.vertical,
    horizontal = options.horizontal;
  if (!orientation) return {};
  return orientation === "vertical" ? vertical : horizontal;
}